(() => {
  if (window.__ougistWarrantyBridgeAsset) return;
  window.__ougistWarrantyBridgeAsset = true;
  window.__ougistJpgCardDownloadPatch = true;

  const freshRegistrationHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const path = url.pathname;
      const isRegistrationPath =
        path.endsWith('/pages/product-registration') ||
        path.endsWith('/pages/product-registration.html') ||
        path.endsWith('/pages/warranty-registration');
      if (!isRegistrationPath) return null;
      url.pathname = path
        .replace('/pages/product-registration.html', '/pages/warranty-registration')
        .replace('/pages/product-registration', '/pages/warranty-registration');
      url.searchParams.set('view', 'default');
      return /^https?:\/\//i.test(href) ? url.href : `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return null;
    }
  };

  const normalizeRegistrationLinks = () => {
    document.querySelectorAll('a[href*="product-registration"], a[href*="warranty-registration"]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const nextHref = freshRegistrationHref(href);
      if (!nextHref) return;
      link.setAttribute('href', nextHref);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeRegistrationLinks, { once: true });
  } else {
    normalizeRegistrationLinks();
  }
  new MutationObserver(normalizeRegistrationLinks).observe(document.documentElement, { childList: true, subtree: true });

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const cardText = (scope, name) => clean(scope.querySelector(`[data-ou-card="${name}"]`)?.textContent);
  const truncate = (value, maxChars) => {
    const text = clean(value);
    if (maxChars && text.length > maxChars) return `${text.slice(0, Math.max(0, maxChars - 3))}...`;
    return text;
  };
  const todayLabel = () => {
    try {
      return new Intl.DateTimeFormat('en', { month: 'short', day: '2-digit', year: 'numeric' }).format(new Date());
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  };
  const setCardText = (scope, name, value) => {
    const el = scope?.querySelector?.(`[data-ou-card="${name}"]`);
    if (el) el.textContent = value;
  };
  const roundedPath = (context, x, y, width, height, radius) => {
    const r = Math.min(radius, width / 2, height / 2);
    context.beginPath();
    context.moveTo(x + r, y);
    context.arcTo(x + width, y, x + width, y + height, r);
    context.arcTo(x + width, y + height, x, y + height, r);
    context.arcTo(x, y + height, x, y, r);
    context.arcTo(x, y, x + width, y, r);
    context.closePath();
  };
  const fillRound = (context, x, y, width, height, radius, fillStyle, alpha = 1) => {
    context.save();
    roundedPath(context, x, y, width, height, radius);
    context.fillStyle = fillStyle;
    context.globalAlpha = alpha;
    context.fill();
    context.restore();
  };
  const strokeRound = (context, x, y, width, height, radius, strokeStyle, alpha = 1) => {
    context.save();
    roundedPath(context, x, y, width, height, radius);
    context.strokeStyle = strokeStyle;
    context.globalAlpha = alpha;
    context.lineWidth = 2;
    context.stroke();
    context.restore();
  };
  const drawText = (context, text, x, y, font, color, maxWidth) => {
    context.save();
    context.font = font;
    context.fillStyle = color;
    context.textBaseline = 'alphabetic';
    context.fillText(text, x, y, maxWidth);
    context.restore();
  };
  const drawField = (context, label, value, x, y, maxChars) => {
    drawText(context, label, x, y, '800 18px Arial, Helvetica, sans-serif', '#9fb0d3', 450);
    drawText(context, truncate(value, maxChars), x, y + 38, '800 26px Arial, Helvetica, sans-serif', '#ffffff', 470);
  };
  const memberCenters = () => [...document.querySelectorAll('#member-center, .ou-member-center')];
  const activeMemberCenter = () => memberCenters().find((node) => !node.hidden && node.offsetParent !== null) || memberCenters()[0];
  const payloadFrom = (memberCenter) => {
    const memberId = cardText(memberCenter, 'memberId') || 'OUG-MEMBER';
    const serial = cardText(memberCenter, 'serial') || 'Registered product';
    const fileSeed = (serial || memberId || 'ougist-warranty-card').replace(/[^a-z0-9-]/ig, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').toLowerCase();
    return {
      memberName: cardText(memberCenter, 'memberName') || 'OUGIST Member',
      memberId,
      serial,
      order: cardText(memberCenter, 'order') || 'OUGIST order',
      coverage: cardText(memberCenter, 'coverage') || 'Extended warranty active',
      activated: cardText(memberCenter, 'activated') || todayLabel(),
      email: cardText(memberCenter, 'email') || 'Email on file',
      fileName: `${fileSeed || 'ougist-warranty-card'}.jpg`,
    };
  };
  const createCanvas = (payload) => {
    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 740;
    const context = canvas.getContext('2d');
    const bg = context.createLinearGradient(0, 0, 1200, 740);
    bg.addColorStop(0, '#16223f');
    bg.addColorStop(0.58, '#243b78');
    bg.addColorStop(1, '#1e315f');
    const orange = context.createRadialGradient(145, 650, 0, 145, 650, 390);
    orange.addColorStop(0, 'rgba(255, 90, 44, 0.50)');
    orange.addColorStop(1, 'rgba(255, 90, 44, 0)');

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    roundedPath(context, 0, 0, canvas.width, canvas.height, 56);
    context.clip();
    context.fillStyle = bg;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = orange;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.globalAlpha = 0.12;
    context.fillStyle = '#ffffff';
    context.beginPath();
    context.arc(1050, 115, 150, 0, Math.PI * 2);
    context.fill();
    context.globalAlpha = 0.18;
    context.fillStyle = '#ff5a2c';
    context.beginPath();
    context.arc(1085, 680, 250, 0, Math.PI * 2);
    context.fill();
    context.restore();

    strokeRound(context, 34, 34, 1132, 672, 40, '#ffffff', 0.22);
    drawText(context, 'OUGIST', 82, 104, '800 46px Arial, Helvetica, sans-serif', '#ffffff', 300);
    fillRound(context, 918, 62, 190, 56, 28, '#e8f8ee');
    context.save();
    context.textAlign = 'center';
    drawText(context, 'ACTIVE', 1013, 98, '800 22px Arial, Helvetica, sans-serif', '#1c7d49', 150);
    context.restore();
    drawText(context, 'DIGITAL WARRANTY MEMBER CARD', 82, 214, '700 22px Arial, Helvetica, sans-serif', '#b9c4dc', 780);
    drawText(context, truncate(payload.memberName, 30), 82, 292, '900 58px Arial, Helvetica, sans-serif', '#ffffff', 860);
    fillRound(context, 82, 322, 360, 48, 24, '#ffffff', 0.10);
    drawText(context, truncate(payload.memberId, 24), 106, 354, '800 25px Arial, Helvetica, sans-serif', '#ffdfd1', 310);
    fillRound(context, 70, 404, 1060, 214, 28, '#ffffff', 0.09);
    strokeRound(context, 70, 404, 1060, 214, 28, '#ffffff', 0.14);
    drawField(context, 'SERIAL NUMBER', payload.serial, 104, 462, 30);
    drawField(context, 'ORDER REFERENCE', payload.order, 640, 462, 28);
    drawField(context, 'COVERAGE', payload.coverage, 104, 558, 34);
    drawField(context, 'ACTIVATED', payload.activated, 640, 558, 22);
    drawText(context, 'EMAIL', 82, 668, '800 18px Arial, Helvetica, sans-serif', '#9fb0d3', 260);
    drawText(context, truncate(payload.email, 46), 82, 704, '800 24px Arial, Helvetica, sans-serif', '#ffffff', 540);
    fillRound(context, 680, 656, 300, 46, 10, '#ffffff', 0.14);
    context.save();
    context.globalAlpha = 0.76;
    context.fillStyle = '#ffffff';
    Array.from({ length: 42 }, (_, index) => {
      const x = 690 + index * 6.5;
      const h = index % 5 === 0 ? 38 : index % 3 === 0 ? 30 : 24;
      context.fillRect(x, 660 + (38 - h), 3.5, h);
    });
    context.restore();
    fillRound(context, 1010, 626, 104, 104, 24, '#ffffff');
    context.save();
    context.textAlign = 'center';
    drawText(context, 'SN', 1062, 690, '900 32px Arial, Helvetica, sans-serif', '#ff5a2c', 80);
    context.restore();
    return canvas;
  };
  const toJpegBlob = (payload) => new Promise((resolve, reject) => {
    createCanvas(payload).toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Unable to create OUGIST warranty card JPG.'));
    }, 'image/jpeg', 0.94);
  });
  const downloadFrom = (memberCenter) => {
    const payload = payloadFrom(memberCenter);
    return toJpegBlob(payload).then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = payload.fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      return { fileName: payload.fileName, mimeType: blob.type, size: blob.size };
    });
  };

  const removeStandaloneMemberLookup = () => {
    document.querySelectorAll('[data-ou-member-lookup]').forEach((card) => card.remove());
  };

  window.ougistDownloadCard = () => {
    const memberCenter = activeMemberCenter();
    return memberCenter ? downloadFrom(memberCenter) : Promise.reject(new Error('OUGIST member card is not visible.'));
  };

  const safeJson = (value, fallback) => {
    try {
      return JSON.parse(value) || fallback;
    } catch (error) {
      return fallback;
    }
  };
  const readWarrantyDraft = () => safeJson(sessionStorage.getItem('ougistWarrantyRegistrationDraft'), {});
  const writeWarrantyDraft = (data) => sessionStorage.setItem('ougistWarrantyRegistrationDraft', JSON.stringify(data));
  const rootForm = () => document.getElementById('mpr-root');
  const isCheckedValue = (value) => {
    const normalized = clean(value).toLowerCase();
    return value === true || normalized === 'true' || normalized === 'yes' || normalized === '1' || normalized === 'on';
  };
  const ensureMarketingOptIn = () => {
    const root = rootForm();
    if (!root) return null;
    const existing = document.querySelector('[data-ou-marketing-opt-in]');
    if (existing) return existing;
    const previous = readWarrantyDraft();
    const emailInput = root.querySelector("input[name='email'], input[type='email']");
    let insertTarget = root;
    if (emailInput && emailInput.parentNode) {
      const field = emailInput.closest?.('label, .form-field, .field, .input, div');
      insertTarget = !field || !field.parentNode || field === root ? emailInput : field;
    }
    if (!insertTarget || !insertTarget.parentNode) return null;
    const wrap = document.createElement('label');
    wrap.className = 'ou-marketing-opt-in';
    wrap.setAttribute('data-ou-marketing-opt-in-wrap', 'true');
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = 'true';
    checkbox.setAttribute('data-ou-marketing-opt-in', 'true');
    checkbox.checked = isCheckedValue(previous.marketingOptIn);
    const text = document.createElement('span');
    text.textContent = 'Send me product safety reminders, replacement notices, and OUGIST offers by email. I can unsubscribe anytime.';
    wrap.appendChild(checkbox);
    wrap.appendChild(text);
    insertTarget.parentNode.insertBefore(wrap, insertTarget.nextSibling);
    return checkbox;
  };
  const rootValue = (selector) => clean(rootForm()?.querySelector(selector)?.value);
  const selectedMultipleProductValue = () => {
    const checked = rootForm()?.querySelector("input[name='multiple-products']:checked");
    return checked ? clean(checked.value) : '';
  };
  const serialFromChip = () => {
    const chips = rootForm()?.querySelectorAll("li, [role='listitem']") || [];
    for (let index = 0; index < chips.length; index += 1) {
      const text = clean(chips[index].innerText || chips[index].textContent).replace(/\bdelete\b/ig, '');
      const matches = text.match(/[A-Z0-9][A-Z0-9-]{7,}/g);
      if (matches?.length) return matches[0];
    }
    return '';
  };
  const collectWarrantyDraft = () => {
    const previous = readWarrantyDraft();
    const marketingControl = ensureMarketingOptIn();
    const serialCandidate = serialFromChip() || rootValue("[data-ou-step-serial], input[name='serialNumbers'], input[placeholder='Input the serial number']");
    const data = {
      order: rootValue("input[placeholder='Input the order number']") || previous.order || '',
      serial: previous.serial && serialCandidate && previous.serial.includes(serialCandidate) && previous.serial.length > serialCandidate.length
        ? previous.serial
        : serialCandidate || previous.serial || '',
      multipleProducts: selectedMultipleProductValue() || previous.multipleProducts || '',
      firstName: rootValue("input[name='firstName']") || previous.firstName || '',
      lastName: rootValue("input[name='last-name']") || previous.lastName || '',
      email: rootValue("input[name='email']") || previous.email || '',
      phone: rootValue("input[name='phone']") || previous.phone || '',
      city: rootValue("input[name='city']") || previous.city || '',
      state: rootValue("input[name='state']") || previous.state || '',
      country: rootValue("input[name='country']") || previous.country || 'US',
      marketingOptIn: marketingControl ? marketingControl.checked : isCheckedValue(previous.marketingOptIn),
    };
    writeWarrantyDraft(data);
    return data;
  };
  const registrationKey = (data) => [data.email, data.serial || data.order].filter(Boolean).join('|').toLowerCase();
  const cardId = (data) => {
    const seed = clean(data.serial || data.order || data.email || Date.now()).toUpperCase();
    const condensed = seed.replace(/[^A-Z0-9]/g, '').slice(-8) || 'MEMBER';
    return `OUG-${condensed}`;
  };
  const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  const backendQueueKey = 'ougistWarrantyBackendSyncQueue';
  const backendStatusKey = 'ougistWarrantyBackendSyncStatus';
  const readBackendQueue = () => safeJson(localStorage.getItem(backendQueueKey), []);
  const writeBackendQueue = (items) => localStorage.setItem(backendQueueKey, JSON.stringify(items.slice(0, 8)));
  const upsertBackendQueueItem = (item) => {
    const next = readBackendQueue().filter((existing) => existing.key !== item.key);
    next.unshift(item);
    writeBackendQueue(next);
  };
  const removeBackendQueueItem = (key) => writeBackendQueue(readBackendQueue().filter((item) => item.key !== key));
  const writeBackendStatus = (key, status, detail = '') => {
    const statuses = safeJson(localStorage.getItem(backendStatusKey), {});
    statuses[key] = {
      status,
      detail: clean(detail),
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(backendStatusKey, JSON.stringify(statuses));
  };
  const sendWarrantyPayload = (item) => fetch(window.ougistWarrantyRegistrationEndpoint || '/apps/ougist-warranty/register', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(item.payload),
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((text) => {
        throw new Error(`HTTP ${response.status} ${text.slice(0, 120)}`);
      });
    }
    return response.json().catch(() => ({ ok: true }));
  });
  const flushWarrantyRegistrationQueue = () => {
    if (!window.fetch) return;
    const now = Date.now();
    readBackendQueue().forEach((item) => {
      if (item.nextAttemptAt && item.nextAttemptAt > now) return;
      const retryItem = {
        ...item,
        attempts: (item.attempts || 0) + 1,
      };
      retryItem.nextAttemptAt = now + Math.min(60 * 60 * 1000, Math.pow(2, retryItem.attempts) * 30 * 1000);
      upsertBackendQueueItem(retryItem);
      writeBackendStatus(retryItem.key, 'sending', 'Sending warranty registration backup');
      sendWarrantyPayload(retryItem)
        .then(() => {
          removeBackendQueueItem(retryItem.key);
          writeBackendStatus(retryItem.key, 'synced', 'Warranty profile and email backup accepted');
        })
        .catch((error) => {
          writeBackendStatus(retryItem.key, 'pending', error?.message || 'Waiting for warranty backend');
        });
    });
  };
  const pushWarrantyRegistration = (data) => {
    const key = registrationKey(data);
    if (!key || !data.email) return;
    const statuses = safeJson(localStorage.getItem(backendStatusKey), {});
    if (statuses[key]?.status === 'synced') return;
    const memberCenter = activeMemberCenter();
    if (!memberCenter) return;
    const payload = payloadFrom(memberCenter);
    toJpegBlob(payload)
      .then(blobToDataUrl)
      .then((imageDataUrl) => {
        upsertBackendQueueItem({
          key,
          attempts: 0,
          createdAt: new Date().toISOString(),
          payload: {
            customer: data,
            warranty: {
              memberId: cardText(memberCenter, 'memberId') || cardId(data),
              coverage: cardText(memberCenter, 'coverage') || 'Extended warranty active',
              activatedAt: new Date().toISOString(),
              sourceUrl: window.location.href,
            },
            card: {
              fileName: payload.fileName,
              imageDataUrl,
            },
          },
        });
        writeBackendStatus(key, 'queued', 'Warranty registration backup queued');
        flushWarrantyRegistrationQueue();
      })
      .catch((error) => {
        writeBackendStatus(key, 'error', error?.message || 'Unable to prepare warranty backup');
      });
  };
  const hasSuccessMessage = () => {
    const text = clean(rootForm()?.innerText || rootForm()?.textContent).toLowerCase();
    return text.includes('registration completed')
      || text.includes('registration is completed')
      || text.includes('registration finished')
      || text.includes('registered successfully')
      || text.includes('thank you')
      || text.includes('thanks');
  };
  const shouldSyncWarranty = () => {
    const memberCenter = activeMemberCenter();
    return hasSuccessMessage() || (memberCenter && memberCenter.hidden === false);
  };
  const checkWarrantyBridge = () => {
    if (!rootForm()) return;
    const data = collectWarrantyDraft();
    if (shouldSyncWarranty()) pushWarrantyRegistration(data);
  };
  const startWarrantyBridge = () => {
    if (window.__ougistWarrantyRegistrationBridgePatch) return;
    window.__ougistWarrantyRegistrationBridgePatch = true;
    if (!rootForm()) {
      window.setTimeout(() => {
        window.__ougistWarrantyRegistrationBridgePatch = false;
        startWarrantyBridge();
      }, 500);
      return;
    }
    removeStandaloneMemberLookup();
    checkWarrantyBridge();
    document.addEventListener('input', checkWarrantyBridge, true);
    document.addEventListener('change', checkWarrantyBridge, true);
    document.addEventListener('click', () => window.setTimeout(checkWarrantyBridge, 260), true);
    window.addEventListener('online', flushWarrantyRegistrationQueue);
    window.setTimeout(flushWarrantyRegistrationQueue, 1200);
    new MutationObserver(checkWarrantyBridge).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWarrantyBridge, { once: true });
  } else {
    startWarrantyBridge();
  }

  document.addEventListener('click', (event) => {
    const action = event.target?.closest?.('[data-ou-card-action="download"]');
    if (!action) return;
    const memberCenter = action.closest('#member-center, .ou-member-center');
    if (!memberCenter) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    downloadFrom(memberCenter).catch(() => {
      action.setAttribute('aria-label', 'Download card unavailable');
    });
  }, true);
})();
